import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const originalPush = Router.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default new Router({
  routes: [
    {
      path: '/',
      name:'HomeRoot',
      component: resolve => require(['@/view/index'], resolve)
    },
    {
      path: '/index',
      redirect: '/',
    },
    {
      path: '/about',
      name:'About',
      component: resolve => require(['@/view/about'], resolve)
    },
	{
	  path: '/school',
	  name:'School',
	  component: resolve => require(['@/view/school'], resolve)
	},
	{
	  path: '/special',
	  name:'Special',
	  component: resolve => require(['@/view/special'], resolve)
	},
	{
	  path: '/promotion',
	  name:'Promotion',
	  component: resolve => require(['@/view/promotion'], resolve)
	},
	{
	  path: '/influence',
	  name:'Influence',
	  component: resolve => require(['@/view/influence'], resolve)
	},
	{
	  path: '/news',
	  name:'News',
	  component: resolve => require(['@/view/news'], resolve)
	},
	{
	  path: '/news/:slug',
	  name:'NewsDetail',
	  component: resolve => require(['@/view/view'], resolve)
	},
	{
	  path: '/contact',
	  name:'Contact',
	  component: resolve => require(['@/view/contact'], resolve)
	},
	{
	  path: '/view',
	  name:'View',
	  beforeEnter: (to, from, next) => {
	    if (to.query && to.query.slug) {
	      next(`/news/${to.query.slug}`)
	    } else {
	      next('/news/')
	    }
	  }
	},
	{
	  path: '/demo',
	  name:'test',
	  component: resolve => require(['@/view/demo'], resolve)
	}
  ],
  mode:'history',
  base: '/',
})
